module.exports = __webpack_public_path__ + "static/media/PACKAGE IN A LOAD.8c080c44.svg";